import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { StripeSubscriptionStatus } from '@workspace/data-types';
import { SubscriptionStatusDisplayPipe } from '@workspace/ng-data-access';

@Component({
  selector: 'aura-subscription-status-chip',
  imports: [SubscriptionStatusDisplayPipe],
  templateUrl: './subscription-status-chip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionStatusChipComponent {
  status = input.required<StripeSubscriptionStatus | string>();

  readonly chipConfig = computed(() => {
    const s = this.status();
    switch (s) {
      case 'active':
        return {
          containerClass: 'bg-jade-3 text-jade-11 border-jade-5',
          dotClass: 'bg-jade-9',
        };
      case 'trialing':
        return {
          containerClass: 'bg-blue-3 text-blue-11 border-blue-5',
          dotClass: 'bg-blue-9',
        };
      case 'past_due':
        return {
          containerClass: 'bg-amber-3 text-amber-11 border-amber-5',
          dotClass: 'bg-amber-9 animate-pulse',
        };
      case 'paused':
        return {
          containerClass: 'bg-amber-3 text-amber-11 border-amber-5',
          dotClass: 'bg-amber-9',
        };
      case 'canceled':
      case 'unpaid':
        return {
          containerClass: 'bg-crimson-3 text-crimson-11 border-crimson-5',
          dotClass: 'bg-crimson-9',
        };
      case 'incomplete':
      case 'incomplete_expired':
      default:
        return {
          containerClass: 'bg-neutral-3 text-neutral-11 border-neutral-5',
          dotClass: 'bg-neutral-9',
        };
    }
  });
}
